<template>
  <div>
    <b-container class="results">
      <b-row>
        <b-col class="mb-4" cols="12">
          <b-card>
            <p class="card-text">
              Hier können Sie die Materialien herunterladen. Der Download sollte automatisch starten. Wenn nicht, klicken Sie bitte auf <a target="_blank" :href="resourceLink" title="Material Herunterladen">Herunterladen</a>.
            </p>

            <div slot="header">
              <h4 class="mt-2 float-left">Material herunterladen</h4>
              <b-button class="float-right" :href="resourceLink" target="_blank" variant="primary">
                <icon name="download"></icon><span class="d-none d-sm-inline"> Herunterladen</span>
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <div style="text-align: center; padding-top: 30px; padding-bottom: 30px">
        <b-button to="/resources/list">Kasa Materialien ansehen</b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
  import Resource from './Resource'
  import ResourceTypeFilter from './ResourceTypeFilter'
  import ResourceLangFilter from './ResourceLangFilter'

  export default {
    name: 'ResourceKasaBook21m',
    data () {
      return {
        resourceLink: '',
        resourceExt: ''
      }
    },
    components: {
      Resource,
      ResourceTypeFilter,
      ResourceLangFilter
    },
    mounted () {
      this.resourceLink = `/static/kasa_book_21/${this.$route.params.item}.${this.$route.params.ext}`
      this.resourceExt = this.$route.params.ext
      setTimeout(() => {
        window.location.href = this.resourceLink
      }, 500)
    }
  }
</script>


<style lang="scss" scoped>
  @import '../style/bootstrap-component-include';
  @import '~animate.css/animate.css';

  .container {
    margin-top: 15px;
  }

  .results {
    min-height: 50vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResourceKasaBook21m.vue